import type { ComponentProps } from "react"
import { cn } from "@/lib/utils"

/** A text input (refined-system §5.13): white, a 3:1 `line-field` border; 16px on a phone (no iOS zoom on focus). */
export function Input({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      className={cn(
        "h-8 w-full min-w-0 rounded-control border border-line-field bg-surface px-2.5 text-[14px] text-ink",
        "max-sm:h-11 max-sm:text-[16px] focus:border-ink read-only:bg-fill-soft",
        className,
      )}
      {...props}
    />
  )
}
